import * as yup from 'yup';

export const confirmInviteSchema = yup.object({
	email: yup.string().email('Invalid email').required('Email is required'),
	otp: yup
		.string()
		.required('OTP is required')
		.matches(/^\d{6}$/, 'OTP must be a 6-digit number'),
	password: yup
		.string()
		.required('Password is required')
		.min(6, 'Password must be at least 6 characters'),
});
